import * as React from 'react'
import styles from './EmbedPrivate.module.scss'
import { Button } from 'components/Button'
import cx from 'classnames'
import { AnchorOrDiv } from './common'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { useModals } from 'almanac-ui/Modal'
import { IntegrationsModal } from 'components/IntegrationsModal/IntegrationsModal'

export type EmbedPrivateProps = {
  mode: 'frame' | 'card' | 'inline'
  link: string
  preview?: true
  icon: React.FunctionComponent<React.PropsWithChildren<React.SVGProps<SVGSVGElement>>>
}

export const EmbedPrivate: React.FC<React.PropsWithChildren<EmbedPrivateProps>> = (props) => {
  const { mode, link, preview, icon: Icon } = props
  const { openModal } = useModals()
  const { isMobile } = useResponsiveDesign()

  const canEnableIntegration = !preview && !isMobile

  switch (mode) {
    case 'frame':
      return (
        <div className={cx(styles.private, styles.frame)}>
          <Icon width={36} height={36} className={styles.icon} />
          <div className={styles.errorMsg}>This link appears to be private</div>

          <AnchorOrDiv className={styles.link} link={preview ? undefined : link}>
            {link}
          </AnchorOrDiv>

          {canEnableIntegration && (
            <Button
              variant="secondary"
              className={styles.enableIntegrationBtn}
              onPress={() => openModal(IntegrationsModal, {})}
            >
              Enable integration
            </Button>
          )}
        </div>
      )
    case 'card':
      return (
        <div className={cx(styles.private, styles.card)}>
          <Icon width={36} height={36} className={styles.icon} />
          <div className={styles.errorMsg}>This link appears to be private</div>
          <AnchorOrDiv className={styles.link} link={preview ? undefined : link}>
            {link}
          </AnchorOrDiv>
          {canEnableIntegration && (
            <Button
              variant="secondary"
              className={styles.enableIntegrationBtn}
              onPress={() => openModal(IntegrationsModal, {})}
            >
              Enable integration
            </Button>
          )}
        </div>
      )
    case 'inline':
      return (
        <div className={cx(styles.private, styles.inline)}>
          <Icon width={16} height={16} />
          <a href={link} rel="noopener noreferrer" target="_blank">
            {link}
          </a>
          {!isMobile && (
            <Button
              variant="tertiary"
              className={styles.enableIntegrationBtn}
              onPress={() => openModal(IntegrationsModal, {})}
            >
              Enable integration
            </Button>
          )}
        </div>
      )
  }
}
